import React, { useContext, useEffect } from 'react';
import { ChartContainer } from './PPAInsightPieCharts.style';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { AppContext } from '../../../../../Context/AppContext';
import { getVolumeByRegionData } from '../../PpaInsightUtils';
import { PPAInsightNoRecords } from '../../PPAInsightNoRecordsPage/PPAInsightNoRecords';

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884d8', '#82ca9d', '#ffc658'];

export const PPAInsightVolByRegionPieChart = () => {
  const { state: ppaInsightState, dispatch: ppaInsightDispatch } =
    useContext(AppContext).ppaInsight;
  useEffect(() => {
    getVolumeByRegionData(ppaInsightDispatch, ppaInsightState.filteredValues);
  }, [ppaInsightState.filteredValues]);

  const chartData = ppaInsightState.volumeByRegionData.map((item) => ({
    name: item.REGION,
    value: item.CAPACITY_EQUIVALENT,
  }));

  return (
    <ChartContainer>
      {ppaInsightState.volumeByRegionData.length === 0 && <PPAInsightNoRecords />}
      {ppaInsightState.volumeByRegionData.length > 0 && (
        <div style={{ width: '100%', height: '400px' }}>
          <h3 style={{ textAlign: 'left', marginBottom: '0.5rem' }}>PPA Volume by Region</h3>
          <p style={{ textAlign: 'left', fontSize: '0.875rem', color: '#666', marginBottom: '1rem' }}>
            An overview of volume by region
          </p>
          <ResponsiveContainer width="100%" height="80%">
            <PieChart>
              <Pie
                data={chartData}
                cx="50%"
                cy="50%"
                labelLine={true}
                label={({ name, percent }) => `${name}: ${((percent ?? 0) * 100).toFixed(0)}%`}
                outerRadius={100}
                fill="#8884d8"
                dataKey="value"
              >
                {chartData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend verticalAlign="top" height={36} />
            </PieChart>
          </ResponsiveContainer>
        </div>
      )}
    </ChartContainer>
  );
};
